import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component({})
export default class PopupLayout extends Vue {
    @Prop({type:String, default:''}) title!:string
    @Prop({type:String, default:''}) stClass!:string
}
